import React, { useState } from 'react';
import { PersonalInfoType, UserInfoType } from './types';

type Props = {
  list: UserInfoType[];
  handleChange: (e: any, i: number) => void;
  title: string;
};
const ProfileInfo = ({ list, handleChange, title }: Props) => {
  const [active, setActive] = useState<PersonalInfoType | null>(null);

  const handleBlur = () => {
    setActive(null);
  };

  return (
    <div className='pt-7 w-full'>
      <label>{title}</label>

      <div className='mt-8 space-y-6'>
        {list?.map(({ label, name, value, disabled }, i) => (
          <div
            key={i}
            onClick={() => setActive(name as PersonalInfoType)}
            className={`flex justify-between flex-row items-center border-b border-b-gray-13 pb-4 text-left ${
              disabled ? 'cursor-not-allowed bg-white' : ''
            }`}>
            <label className='text-gray-9'>{label}</label>
            <input
              onChange={(e) => handleChange(e, i)}
              onBlur={handleBlur}
              name={name}
              disabled={disabled}
              value={value ? value : ''}
              className={`basis-3/4 text-right border-none outline-none ${
                disabled ? 'cursor-not-allowed bg-white' : ''
              } `}
              dir={active === name ? 'ltr' : 'rtl'}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileInfo;
